export const SITE_URL = 'https://www.i3design.jp'
export const ORGANIZATION_ID = `${SITE_URL}/#organization`
export const ORGANIZATION_NAME = '株式会社アイスリーデザイン'
export const OGP_LOGO = `${SITE_URL}/ogp_logo.png`
export const SERVICE_OGP_IMAGE = `${SITE_URL}/img/ogp_logo.png`
export const WEBSITE_NAME = 'i3DESIGN アイスリーデザイン'
